import React from 'react';

import { Stack, Text, Checkbox } from '@quotient/riq-react-ui';

const RenderSortFilters = ({ sortFilters = [], filterHeading, currentFilter, setCurrentFilter }) => {
  if (!sortFilters) return null;

  // update current filters on change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    const filters = [...currentFilter];

    if (target.checked) {
      filters.push(target.value);
    } else {
      const index = filters.indexOf(target.value);
      filters.splice(index, 1);
    }

    setCurrentFilter(filters);
  };

  return (
    <fieldset style={{ padding: '20px', border: 0, minWidth: 0, background: '#EFEFEF' }}>
      <Stack direction="vertical" gap={5}>
        <legend style={{ width: '100%', border: 0, borderBottom: '1px solid' }}>
          <Text weight="bold">{filterHeading}</Text>
        </legend>
        <Stack gap={3}>
          {sortFilters.map((filter) => (
            <Checkbox
              key={filter.id}
              id={filter.id}
              name={filter.name}
              value={filter.source}
              label={filter.name}
              onChange={handleChange}
            />
          ))}
        </Stack>
      </Stack>
    </fieldset>
  );
};

export { RenderSortFilters };
